/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/

import React from 'react';
import {fetchFeed} from '../apiFunctions';
import MasonryColumn from './masonryColumn.jsx';

import T from 'i18n-react';
import Infobox from "./infobox.jsx";
import store from '../store';
import { connect } from 'react-redux';
import Spinner from './modal/spinner.jsx';





class MagazineCopy extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      columns:[],
      bufferElements: [],
      nrOfNewElements: 0,
      showLoading:false,
      uniqueKey:null,
      top:true
    }

    this.onResize = this.onResize.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.fetchMoreElements = this.fetchMoreElements.bind(this);
    this.updateMasonry = this.updateMasonry.bind(this);


    this.scrollRef = "masonryContainer"
    this.isAddingElements = false;
    this.isFetching = false;

    this.scrollEventHandler = this.throttle(this.onScroll,10);

  }


  componentWillMount(){
    this.onResize();
  }
  componentDidMount () {
    // setTimeout(() => {
    //   Perf.start();
    //   setTimeout(() => {
    //     Perf.stop();
    //     const measurements = Perf.getLastMeasurements();
    //     Perf.printWasted(measurements);
    //   }, 3000);
    // }, 500);

    if( typeof window !== 'undefined' ){
      window.addEventListener('resize', this.onResize, false)
      this.refs.masonryContainer ? this.refs.masonryContainer.addEventListener('scroll',this.scrollEventHandler) : null
    }

    // if(this.props.children.length<15){
    //     console.log("FETCHING DID MOUNT")

    //   this.fetchMoreElements()
    //   this.updateMasonry(this.getNrOfColumns())
    // }
  }

  componentWillUnmount () {
    if( typeof window !== 'undefined' )
      window.removeEventListener('resize', this.onResize)
      this.refs.masonryContainer.removeEventListener('scroll',this.scrollEventHandler)
  }
  componentDidUpdate(prevProps, prevState){


    const scrollDiv = this.refs[this.scrollRef]
    const hasOverflowingChildren = scrollDiv.offsetHeight < scrollDiv.scrollHeight || scrollDiv.offsetWidth < scrollDiv.scrollWidth;
    if(!hasOverflowingChildren){
      this.moveBufferElementsToColumns(5)
    }
    // console.log('hasOverflowingChildren')
    // console.log(hasOverflowingChildren)

    if(this.props.feed.refresh !== prevProps.feed.refresh){
      //WHEN A PUFF IS SAVED/EDITED AND REDUX UPDATED
      this.updateMasonry(this.getNrOfColumns());
    }


    if(this.props.feed.isFetching && this.props.feed.puffs.length===0 && this.state.nrOfNewElements!==0){
      // this is when we are in the middle of a new fetch. With new query/new sort
      // (redux state = FEED_REQUEST)
      // console.log("SHOULD CLEAR MASONRY")

      this.updateMasonry(this.getNrOfColumns());
    }
    // console.log("-------- UPDATE! ------------");
    if(prevProps.feed.isFetching && !this.props.feed.isFetching){
      //Request is done, we've got a response
      // console.log(this.props.feed.lastRequest.query,prevProps.feed.lastRequest.query)
      this.isFetching=false;
      if (this.props.feed.lastRequest.error) {
        // TODO: internet is down, show message
        // console.log("EEERRRRORRRRR")
        // console.log(this.props.feed.lastRequest.error)
      }else{
        if(this.props.feed.lastRequest.query!=prevProps.feed.lastRequest.query){
          // console.log("-------- NEW QUUEERRRYYYYY! ------------");
          // This is when we have a new query and need to update the masonry
          this.updateMasonry(this.getNrOfColumns());
          return;
        }

        if(this.props.feed.lastRequest.offset===0 || !this.props.feed.lastRequest.offset){
          // console.log("-------- ZERO OFFSET! ------------");
          //Used when updating sort (in menu). The offset will be 0
          // because we have to refetch everything, therefore we update the masonry
          return this.updateMasonry(this.getNrOfColumns())
        }

        if(prevProps.feed.lastRequest.offset<this.props.feed.lastRequest.offset){
          // console.log("-------- GOT MOOOOOOORE! ------------");
          // When scrolling down, we get more elements (and the offset will increase)
          return this.moveElementsToBuffer()
        }
      }

    }


  }

  fetchMoreElements(offset=this.props.children.length){
    if(!this.isFetching){
      this.isFetching=true;
      fetchFeed(this.props.feed, offset);
    }
  }

  updateMasonry(nrOfColumns, elements=this.props.children){
    let columns = [];
    for (let i = 0; i < nrOfColumns; i++) {
      columns[i] =[];
    }

    let j = 0;
    for(let i = 0;i<elements.length;i++){
      columns[j].push(elements[i]);
      j++;
      if(j>=nrOfColumns){
        j=0;
      }
    }
    const uniqueKey = JSON.stringify({
      // ...this.props.feed,
      feedID:this.props.feed.puffs.map(p=>p.id),
      puffs:this.props.feed.puffs.length,
      menu:null,
    })
    this.setState({columns:columns, bufferElements:[], uniqueKey:uniqueKey, nrOfNewElements:elements.length})
  }
  getNrOfColumns(){
    let columnMinWidthRules = [800,1200,1600] //1600
    let nrOfColumns = columnMinWidthRules.length;
    for (let i = 0; i < columnMinWidthRules.length; i++) {
      let minimumWidth = columnMinWidthRules[i];
      if(window.innerWidth<=minimumWidth){
        nrOfColumns = i+1;
        break;
      }
    }
    return nrOfColumns;
  }
  onResize (){
    const nrOfColumns = this.getNrOfColumns();
    if(this.state.columns.length!=nrOfColumns){
      this.updateMasonry(nrOfColumns);
    }
  }
  throttle(fn, wait) {
    var time = Date.now();
    return function(event) {
      if ((time + wait - Date.now()) < 0) {
        fn(event);
        time = Date.now();
      }
    }
  }
  onScroll(){
    let scrollTop = this.refs[this.scrollRef].scrollTop;
    let masonryContainerHeight = this.refs[this.scrollRef].clientHeight;
    let columnsContainerHeight = this.refs.columnsContainer.clientHeight;
    if( scrollTop > columnsContainerHeight - (masonryContainerHeight) - 100 ){
      const columnsContainerHeight = this.refs.columnsContainer.clientHeight;
      this.moveBufferElementsToColumns(5);


    }
  }

  moveElementsToBuffer(){
    if(this.props.children.length>0){
      let bufferElements = [...this.state.bufferElements];
      let totalNrOfPuffs = this.state.columns.reduce((a,col)  =>{
        return  a + col.length
      }, 0)
      for (let i = totalNrOfPuffs+bufferElements.length; i < this.props.children.length; i++) {
        const el = this.props.children[i];
        bufferElements.push({element:el,ref:"bufferElements-"+el.key});
      }
      return this.setState({bufferElements:bufferElements});
    }
  }

  moveBufferElementsToColumns(max=this.state.bufferElements.length){

    max = Math.min(max,this.state.bufferElements.length);
    if(this.state.bufferElements.length>0){
      let columns = this.state.columns.slice();
      let colLengths = this.state.columns.map((col,i)=>{
        return this.refs['maysonrycolumn'+i].height();
      });
      for (let i = 0; i < max; i++) {
        const el = this.state.bufferElements[i];
        const height = this.refs[el.ref].clientHeight;
        const minHeightColIndex = colLengths.indexOf(Math.min(...colLengths));
        colLengths[minHeightColIndex] = colLengths[minHeightColIndex]+ height;
        columns[minHeightColIndex].push(el.element);
      }
      const slicedBuffer = this.state.bufferElements.slice(max);
      // console.log("BEFORE SLICE");
      // console.log(this.state.bufferElements);
      // console.log("AFTER SLICE")
      // console.log(slicedBuffer);
      return this.setState({columns,bufferElements:slicedBuffer})
    }
    // Fetch more if needed
    if(this.state.bufferElements.length<5){
      this.fetchMoreElements();
    }


  }

  feedPath(feed){
    return '/' + (feed.prefix ? feed.prefix + '/' : '') + feed.id
  }

clearMasonry(){
  // console.log("clearing");
  this.setState({columns:[], bufferElements:[]})
}



  render() {

    let style = {
      rowFill:{display: 'flex', flexDirection: 'column', flex: 1, overflowY:'auto', overflowX:'hidden'},
      column:{
        float:"left",
        width:100/this.state.columns.length+"%",
        // paddingLeft:'15px'
      },
      spinner:{
        margin:'auto',
        paddingTop:30},
      noResultsFound:{
        width: "100%",
        textAlign: "center",
        marginTop: "15px",
        color: "rgb(119, 119, 119)"
      }
    }

    let bufferElements = null;

    if(this.state.bufferElements){
      bufferElements = this.state.bufferElements.map(el=>{
        return(<div style={style.column} key={el.ref} ref={el.ref}>{el.element}</div>)
      });
    }

    // console.log('Masonry feed')
    // console.log(this.props.feed)
    // console.log("bufferElements")
    // console.log(this.state.bufferElements)
    // console.log("children")
    // console.log(this.props.children)
    // console.log("this.state.columns")
    // console.log(this.state.columns)

    // const noResultsFound = (this.props.feed && this.props.feed.lastRequest.query && this.props.children.length===0 && !this.props.feed.isFetching)
    // const searchPage = (this.props.feed && this.props.feed.id==='search' && this.props.children.length===0 )

    // const hasMore=this.state.bufferElements.length>1;
    var selected = this.props.selectedPuff && this.props.selectedPuff.tabId === this.props.feed.id

    let feedConfig = this.props.feed && this.props.feed.plugins && this.props.feed.categoryFilter
    var article = this.props.selectedPuff
    return (
      <div style={{overflowY:'hidden', height:'100%', ...(this.props.style ? this.props.style : {})}}>
        <div onScroll={this.props.updateScroll}
            id={this.props.scrollId}
            ref={this.scrollRef}
            style={{...{paddingBottom: '15%',
                        overflowY:'scroll',
                        WebkitOverflowScrolling: 'touch',
                        height:'100%',
                        width:'100%'},
                        ...style.rowFill}}>


          <div ref="columnsContainer" className="container">

          {this.props.myFeeds ? this.props.myFeeds : null}

          {feedConfig ? null : <Infobox newButton={this.props.newButton} loading={this.props.feed.isFetching} feed={this.props.feed} info={this.props.feed.info}/>}



            {this.state.columns.map((c,i)=>{
              return(
                <MasonryColumn
                  style={style.column}
                  key={this.props.id+"-maysonrycolumn-"+i+"-"+this.state.uniqueKey}
                  id={this.props.id+"-maysonrycolumn-"+i+"-"+this.state.uniqueKey}
                  ref={"maysonrycolumn"+i}
                  scrollRef={this.scrollRef}
                  chunkSize={(this.props.chunkSize?this.props.chunkSize:3)}>
                    {c}
                </MasonryColumn>)
            })}

          </div>
          {this.props.feed.isFetching ? <div style={style.spinner}><Spinner/></div> : null}
        </div>

        <div style={{visibility:'hidden'}} className="container">
          {bufferElements}
        </div>
      </div>
    );
  }


}

const mapStateToProps = function(store) {
  return {
    selectedPuff: store.puff.selectedPuff.puff
  };
};

export default connect(mapStateToProps)(MagazineCopy);
